import cn from 'classnames';
import style from './ButtonCall.module.scss';

function ButtonCall({ className, handleFuction, text }) {
  return (
    <button className={cn(style.buttonCall, className)} onClick={handleFuction} data-testid='footerFormOpen'>
      <span>{text}</span>
    </button>
  );
}

export default ButtonCall;
